module.exports = __webpack_public_path__ + "static/mary-kay-4-ba26feb293ccd7659774e7b5d46904cb.jpg";